<template>
    <div class='container' ref="containerBox" @scroll="handleScroll">
        <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
            :style="{ background: isSticky ? '#fff' : 'transparent' }">
            <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
        </div>
        <div class='contentBox'>
            <!-- <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="item in 4" :key="item">
                <el-image :src="src" style="width: 100%;height: 100%; " fit="fill"></el-image>
            </el-carousel-item>
        </el-carousel> -->
            <!-- <el-image :src="require(`@/static/image/index/aboutus.png`)"
                style="width: 100%;height: 320px;min-width: 1200px;" fit="fill"></el-image> -->
            <img :src="about_top_banner || require(`@/static/image/index/aboutus.png`)" alt="carousel image"
                style="width: 100%;height: auto;min-width: 1200px;" />
            <div class="content">
                <div class="flex-between" style="align-items: flex-start;">
                    <div v-html="richContent" class="leftcontent" style="flex: 0 47%;"></div>
                    <div class="rightcontent" style="flex: 0 50%;">
                        <el-image :src="imagePic || require(`@/static/image/detailes/gs.jpg`)"
                            style="width: 100%;max-width: 738px;" fit="fill"></el-image>
                    </div>
                </div>
                <div class="flex-between" style="margin: 100px auto;">
                    <div class="leftcontent" style="flex: 0 50%;">
                        <!-- <el-image :src="require(`@/static/image/index/aboutus.png`)" style="width: 100%;height: 320px;"
                        fit="fill"></el-image> -->
                        <div id="mapContainer" style="width: 100%;height: 414px;max-width: 738px;"></div>
                    </div>
                    <div class="rightcontent" style="flex: 0 47%;">
                        <div class="title" style="font-size: 24px;">联系我们</div>
                        <div class="flex" style="margin-top: 30px;">
                            <el-image :src="require(`@/static/image/index/icon7.png`)"
                                style="width:40px;height:40px;margin-right:16px;" fit="fill"></el-image>
                            <div class="title" style="font-size: 20px;">{{ info.service_phone || '' }}</div>
                        </div>
                        <div class="flex" style="margin-top: 30px;">
                            <el-image :src="require(`@/static/image/index/icon8.png`)"
                                style="width:40px;height:40px;margin-right: 16px;" fit="fill"></el-image>
                            <div class="title" style="font-size: 18px;">{{ info.email || '' }}</div>
                        </div>
                        <div class="flex" style="margin-top: 30px;">
                            <el-image :src="require(`@/static/image/index/icon9.png`)"
                                style="width:40px;height:40px;margin-right: 16px;" fit="fill"></el-image>
                            <div class="title" style="font-size: 18px;">{{ info.address || '' }}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <fotterVue></fotterVue>
    </div>
</template>

<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=NK2BZ-2BYKN-D7OFD-SRE2E-E5LSQ-6CBPZ"></script>
<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';  
export default {
    name: '',
    components: {
        titlePage,
        fotterVue,  
    },
    data() {
        return {
            src: "require(`@/static/image/index/icon1.png`)",
            richContent: "",
            isSticky: false,
            stickyBoxTop: 0,
            info:{},
            map: null, // 存储地图实例
            marker: null, // 存储标记实例
            // markers: [],
            imagePic:localStorage.getItem('about_pic'),
            about_top_banner:localStorage.getItem('about_top_banner'),
        };
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() {
        this.scrollToTop()
        this.getCon()
        this.getConfig()
    },
    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop
            this.isSticky = scrollTop > this.stickyBoxTop;
        },
        scrollToTop() {
            this.$refs.containerBox.scrollTop = 0;
        },
        getCon() {
            this.$api.index.getCon({ type: 'company_desc' }).then(res => {
                if (res.code == 200) {
                    this.richContent = res.data || []
                }
            })
        },
        getConfig(){ 
            this.$api.index.getConfig().then(res => { 
                if (res.code == 200) { 
                    this.info =  res.data ||{}      
                    this.initMap();
                }
            })
        },
        initMap() {
             // 初始化地图
            this.map = new window.qq.maps.Map(document.getElementById('mapContainer'), {
              center: new window.qq.maps.LatLng(this.info.latlng.split(',')[0],this.info.latlng.split(',')[1]), // 设置中心点
              zoom: 14, // 设置缩放级别
            });  
            console.log(this.info.latlng.split(',')); 
            this.marker = new window.qq.maps.Marker({
              position: new window.qq.maps.LatLng(this.info.latlng.split(',')[0],this.info.latlng.split(',')[1]),
              map: this.map,
            });
        },
    },
}
</script>
<style lang='scss' scoped>
.contentBox {
    background: linear-gradient(0deg, #F6F8FE 0%, #F6F8FE 78%, #CEEAFF 100%);
    margin-top: 60px;
    min-height: 55vh;
}

.content {
    padding: 50px 0;
    // margin: 0 auto; 
}

::v-deep .el-carousel__container {
    height: 320px;
}
</style>